import { render } from "./RewardsPoints.vue?vue&type=template&id=b00257ca&scoped=true"
import script from "./RewardsPoints.vue?vue&type=script&lang=js"
export * from "./RewardsPoints.vue?vue&type=script&lang=js"

import "./RewardsPoints.vue?vue&type=style&index=0&id=b00257ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00257ca"]])

export default __exports__